import React from 'react';
import { NightPhaseLanding } from './components/NightPhaseLanding';
export function App() {
  return <NightPhaseLanding data-id="element-0" />;
}